if(!navigator.cookieEnabled) {
  alert('You seem to have disabled your browser\'s cookies. To use Quill, you must enable them.')
}
